"use strict";

import angular from "angular";

import template from "./help-item-faq.component.html";
import "./themes/help-item-faq.component.scss";
import "./themes/help-item-faq-dark.component.scss";

class HelpItemFaqComponent {
    constructor() {}

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {}
}

HelpItemFaqComponent.$inject = [];

const name = "helpItemFaqComponent";
const def = {
    bindings: {
        content: "<"
    },
    controller: HelpItemFaqComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
